import React from 'react';
import SVGLoader from './SVGLoader';

const AviveWarningIcon = props => {
  const { width, height, viewboxWidth, viewboxHeight, ...rest } = props;

  return (
    <SVGLoader
      {...rest}
      width={width || 15}
      height={height || 15}
      viewboxWidth={viewboxWidth || 15}
      viewboxHeight={viewboxHeight || 12}
    >
      <path
        d="M11.8504 2.68368L6.90133 9.83025C6.66133 10.1789 6.3491 10.4619 5.98972 10.6563C5.63034 10.8507 5.23383 10.9513 4.83203 10.9498C4.1811 10.926 3.5636 10.632 3.10762 10.1288L0.486505 7.3672C0.367109 7.23886 0.272352 7.08624 0.207691 6.91811C0.14303 6.74999 0.109741 6.56968 0.109741 6.38758C0.109741 6.20548 0.14303 6.02517 0.207691 5.85705C0.272352 5.68892 0.367109 5.5363 0.486505 5.40796C0.719956 5.17049 1.02831 5.03828 1.34871 5.03828C1.66912 5.03828 1.97747 5.17049 2.21092 5.40796L4.50439 7.74039C4.54618 7.78777 4.59742 7.82417 4.65421 7.84681C4.711 7.86945 4.77183 7.87773 4.83203 7.87101C4.89391 7.86966 4.95455 7.85195 5.00865 7.81943C5.06275 7.7869 5.10868 7.74055 5.14242 7.68441L9.79835 0.96701C10.0017 0.696038 10.2914 0.5171 10.6104 0.465316C10.9294 0.413533 11.2549 0.492643 11.5228 0.687119C11.6709 0.789961 11.7978 0.924849 11.8954 1.0833C11.993 1.24176 12.0593 1.42036 12.0901 1.60787C12.1209 1.79538 12.1154 1.98775 12.0742 2.17289C12.033 2.35803 11.9568 2.53194 11.8504 2.68368Z"
        fill="currentFill"
      />
    </SVGLoader>
  );
};

export default AviveWarningIcon;
